module.exports = __webpack_public_path__ + "static/media/icon-7.7584d112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-7.png
// module id = 1032
// module chunks = 0